<template>
	<a
		class="nav-meta__list-item-link"
		@click.prevent="onCartOpen"
		href="javascript:void(0)"
	>
		<span
			class="nav-meta__list-item-text"
			v-if="!hasBasket"
			v-html="$t('cart.iconLabel')"
		/>
		<SVGBag class="nav-meta__list-item-icon"/>
		<span
			class="nav-meta__list-item-count"
			v-if="totalItemsWithoutAdditional && !publicMode"
			v-html="totalItemsWithoutAdditional"
		/>
	</a>
</template>

<script>
import { mapGetters } from "vuex"
import htmlComponent from "htmlcomponent"
import scrrroll from 'scrrroll';

export default {
	mixins: [],
	components: {},
	data() {
		return {
			overlayType: 'sidebar-cart',
		};
	},
	computed: {
		...mapGetters("cart", [
			"total",
			"totalItemsWithoutAdditional",
			"hasBasket",
			"showContinue",
		]),
		...mapGetters("productlist", [
			"publicMode",
		])
	},
	methods: {
		onCartOpen() {
			if (this.hasBasket && !this.publicMode) {
				htmlComponent.send('overlay:toggle', {type: this.overlayType});
			} else if (this.isHome) {
				scrrroll.toTop();
			} else {
				htmlComponent.send('overlay:toggle', {type: 'overlay-orderbox'});
			}
		}
	}
}
</script>

<style></style>
